export const Guide = {
  fr: {
    '/': {
      icon: 'home',
      title: 'Home',
      data: [
        {
          class:'mat-nav-list > div:nth-child(1)',
          title:'Suivi présence et traitement des incohérences',
          description:`
      <p>Après avoir cliqué sur « Suivi présence et traitement des incohérences », Les équipes affectés au collaborateur connecté sont affichées.</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'timesheet|[use="sites_list"]:first-child'
        },
        {
          class:'mat-nav-list > div:nth-child(2)',
          title:'',
          description:``
        },
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Export pointage',
          description:`
      <strong>Cliquer sur « Export pointage »</strong>
      <p>Les blocs de temps exportés sont listés au niveau de l’export pointage.</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
        }
      ]
    },
    timesheet: {
      icon: 'av_timer',
      title: 'Suivi présence et traitement des incohérences',
      data: [
        {
          class:'[use="sites_list"]:first-child',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Cliquer sur le site à visualiser</li>
  </ul>`,
          contains:'[use="sites_list"]:first-child mat-list-item-content',
          to: 'timesheet|[use="teams_list"]:nth-child(1)'
        },
        {
          class:'[use="teams_list"]:nth-child(1)',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Cliquer sur l’équipe</li>
      </ul>`,
          to: 'timesheet|[use="persons_list"]:first-child'
        },
        {
          class:'[use="persons_list"]:first-child',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
              <li>Cliquer sur l’agent à consulter ou valider</li>
        </ul>`,
          to: 'timesheet|.accordin'
        },
        {
          class:'.accordin',
          title:'Consulter des blocs de temps',
          description:`
            <ul>
                <li>Les blocs de temps de l’agent sont affichés</li>
            </ul>
            `,
          useQuestion:true,
          suggestion: [
            'timesheet|.regenerer',
            'timesheet|.validate' ,
            'timesheet|#g_data .dataset:nth-child(1)' ,
            'timesheet|#g_data .dataset:nth-child(2)' ,
            'timesheet|#g_data .dataset:nth-child(3)'
          ]
        },
        {
          class:'.formExport',
          title:'Exporter des blocs de temps',
          description:`
        <ul>
          <li>
            Pour exporter le contenu des blocs de temps au format CSV :
            <ul  class="ul-left-pd ul-top-pd">
                <li>Saisir la date de début</li>
                <li>Saisir la date de fin</li>
                <li>Cliquer sur « Exporter »</li>
            </ul>
          </li>
        </ul>
      `,
          useQuestion:true,
        },
        {
          class:'#g_data .dataset:nth-child(1)',
          title:'Le prévu',
          description:`<p>
          Les données de présences prévues pour le collaborateur: Ces données sont collectées depuis l'outil de planification, et de MyCongés.
  </p>`,
          to:'#g_data .dataset:nth-child(2)',
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(2)',
          title:'Le réalisé',
          description:`<p>
  Les états de présences réalisés par le collaborateur.
  </p>`,
          to:'#g_data .dataset:nth-child(3)',
          actions: [
            {
              label: 'Prev',
              action: 'back',
              class: 'btn'
            },
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(3)',
          title:'Le réalisé validé ',
          description:`<p>
  Le résultat du croisement entre les données du prévu et celles du réalisé. <br>
  <strong> NB: </strong> Aucune validation n'est possible avant la fin du shift.
  </p>`,
        to: 'timesheet|.motifs-card'
        },
        {
          class:'.regenerer',
          title:'Régénérer le planning',
          description:`
          <ul>
            <li>Cliquer sur le bouton régénérer prévu. Le prévu s’affiche si cet agent a un prévu sur cette journée</li>
            <li><strong style="color: red">NB:</strong> La régénération du prévu n’est possible que dans le cas d’absence du prévu</li>
          </ul>
        `,
          useQuestion:true
        },
        {
          class:'.validate',
          suggestion: [
            'timesheet|#g_data .dataset:nth-child(3)'
            ],
          title:'Valider les blocs de temps',
          description:`
      <ul>
        <li>Justifier les incohérences en double cliquant sur le bloc d’incohérence, le pop-up des motifs s’affiche pour y renseigner les motifs. Il est possible de splitter les blocs de temps en modifiant les durées.</li>
        <li>Cliquer sur sauvegarder</li>
        <li>Cocher le bouton « Valider »</li>
      </ul>
    `,
          useQuestion:true
        },
        {
          class:'.motifs-card',
          title:'Le réalisé validé ',
          description:`

  <p>En cliquant sur le bloc de temps d’incohérence une fenêtre pop-up s’affiche pour y renseigner les motifs d’incohérences.
  Les motifs d’incohérence sont affichés au niveau de la liste déroulante, selon la nature de l’incohérence. Deux listes sont distinguées une liste pour les incohérences en moins et une autre pour les incohérences en plus.
  Il est possible de splitter les durées en modifiant les heures.</p>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-content .mat-grid-list',
          title:'Le réalisé validé ',
          description:`
          <p>Il est possible de splitter les blocs de temps pour se faire:</p>
  <ul>
    <li>1. changer le motif</li>
    <li>2. cliquer sur l'intervalle de temps</li>
    <li>3. Modifier les heures</li>
  </ul>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-actions .mat-button:nth-child(2)',
          title:'Le réalisé validé ',
          description:`Valider`,
          to: 'timesheet|close'
        }
      ]

    },
    mytimesheet: {
      icon: "timelapse",
      title: "Mes états de présence",
      data: [
        {
          class:'.accordin',
          title:'Consulter des blocs de temps',
          description:`
            <ul>
                <li>Les blocs de temps de l’agent sont affichés</li>
            </ul>
            `,
          useQuestion:true,
          }
      ]
    },
    "export": {
      icon: "import_export",
      title: "Export pointage",
      data: [
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Export pointage',
          description:`
      <p>Les blocs de temps exportés sont listés au niveau de l’export pointage.</p>
      <p>Cliquer sur « Export pointage »</p>    `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
          /*suggestion: ['timesheet|.accordin']*/
        },
        {
          class:'.mat-row .mat-checkbox-inner-container',
          title:'Export pointage',
          description:`
              <br>
              <p>Cocher l’export ou les exports à télécharger</p>
              `,
          contains:'mat-checkbox-inner-container',
          to: 'export|.downloadExportSheet'
        },
        {
          class:'.downloadExportSheet',
          title:'Télécharger',
          description:`
              <br>
              <p>Cliquer sur Télécharger</p>
              `,
          contains:'downloadExportSheet',
          to: 'export|close'
        },

      ]
    }
  },
  en: {
    '/': {
      icon: 'home',
      title: 'Home',
      data: [
        {
          class:'mat-nav-list > div:nth-child(1)',
          title:'Attendance follow-up and processing of inconsistencies',
          description:`
          <p>After clicking on « Attendance follow-up and processing of inconsistencies », the teams assigned to the connected employee are displayed.</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'timesheet|[use="sites_list"]:first-child'
        },
        {
          class:'mat-nav-list > div:nth-child(2)',
          title:'',
          description:``
        },
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Export clocking',
          description:`
      <strong>Click on « Export clocking »</strong>
      <p>Click on « Export clocking »</strong> <p>The exported time blocks are listed in the export clocking.</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
        }
      ]
    },
    timesheet: {
      icon: "av_timer",
      title: "Attendance follow-up and processing of inconsistencies",
      data: [
        {
          class:'[use="sites_list"]:first-child',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Click on the site to view</li>
  </ul>`,
          contains:'[use="sites_list"]:first-child mat-list-item-content',
          to: 'timesheet|[use="teams_list"]:nth-child(1)'
        },
        {
          class:'[use="teams_list"]:nth-child(1)',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Click on the team</li>
      </ul>`,
          to: 'timesheet|[use="persons_list"]:first-child'
        },
        {
          class:'[use="persons_list"]:first-child',
          title:'Guide',
          description:`<ul class="ul-left-pd ul-top-pd">
              <li>Click on the agent to view or approve</li>
        </ul>`,
          to: 'timesheet|.accordin'
        },
        {
          class:'.accordin',
          title:'View time blocks',
          description:`
            <ul>
                <li>The agent's time blocks are displayed</li>
            </ul>
            `,
          useQuestion:true,
          suggestion: [
            'timesheet|.regenerer',
            'timesheet|.validate' ,
            'timesheet|#g_data .dataset:nth-child(1)' ,
            'timesheet|#g_data .dataset:nth-child(2)' ,
            'timesheet|#g_data .dataset:nth-child(3)'
          ]
        },
        {
          class:'.formExport',
          title:'Export time blocks',
          description:`
        <ul>
          <li>
          To export the content of the time blocks in CSV format :
            <ul  class="ul-left-pd ul-top-pd">
                <li>Enter the start date</li>
                <li>Enter the end date</li>
                <li>Click on « Export »</li>
            </ul>
          </li>
        </ul>
      `,
          useQuestion:true,
        },
        {
          class:'#g_data .dataset:nth-child(1)',
          title:'Planned schedule',
          description:`<p>
          The planned attendance data for the employee: This data is collected from the planning tool and from MyCongés.
  </p>`,
          to:'#g_data .dataset:nth-child(2)',
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(2)',
          title:'Completed data',
          description:`<p>
          Employee's attendance records
  </p>`,
          to:'#g_data .dataset:nth-child(3)',
          actions: [
            {
              label: 'Prev',
              action: 'back',
              class: 'btn'
            },
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(3)',
          title:'Completed and approved ',
          description:`<p>
          The result of the cross-referencing between the planned and completed data.<br>
  <strong> Note: </strong> No approval is possible before the end of the shift.
  </p>`,
        to: 'timesheet|.motifs-card'
        },
        {
          class:'.regenerer',
          title:'Regenerate the schedule',
          description:`
          <ul>
            <li>Click on the regenerate planned schedule button. The planned schedule is displayed if this agent has a shift scheduled on this day.</li>
            <li><strong style="color: red">NB:</strong>You can only regenerate the planned if the planned schedule is absent.</li>
          </ul>
        `,
          useQuestion:true
        },
        {
          class:'.validate',
          suggestion: [
            'timesheet|#g_data .dataset:nth-child(3)'
            ],
          title:'Approve the time blocks',
          description:`
      <ul>
        <li>Explain the inconsistencies by double clicking on the inconsistency block, the pop-up of the reasons is displayed for you to fill in the reasons. You can split the time blocks by modifying the duration.</li>
        <li>Click on save</li>
        <li>Check the « Approve » button.</li>
      </ul>
    `,
          useQuestion:true
        },
        {
          class:'.motifs-card',
          title:'Completed and approved ',
          description:`

  <p>By clicking on the inconsistent time block, a pop-up window is displayed for you to enter the reasons for the inconsistency. The reasons for inconsistency are displayed in the drop-down menu, according to the nature of the inconsistency. Two menus are displayed: one for the minus inconsistencies and another for the plus inconsistencies. It is possible to split the durations by modifying the hours.</p>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-content .mat-grid-list',
          title:'Completed and approved ',
          description:`
          <p>You can split the time blocks, to do so:</p>
  <ul>
    <li>1. change the reason</li>
    <li>2. click on the time interval</li>
    <li>3. Change the times</li>
  </ul>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-actions .mat-button:nth-child(2)',
          title:'Completed and approved ',
          description:`Approve`,
          to: 'timesheet|close'
        }
      ]

    },
    mytimesheet: {
      icon: "timelapse",
      title: "My attendance records",
      data: [
        {
          class:'.accordin',
          title:'View time blocks',
          description:`
            <ul>
                <li>The agent's time blocks are displayed</li>
            </ul>
            `,
          useQuestion:true,
          }
      ]
    },
    "export": {
      icon: "import_export",
      title: "Export clocking",
      data: [
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Export clocking',
          description:`
      <p>The exported time blocks are listed in the export clocking.</p>
      <p>Click on « Export clocking »</p>    `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
          /*suggestion: ['timesheet|.accordin']*/
        },
        {
          class:'.mat-row .mat-checkbox-inner-container',
          title:'Export clocking',
          description:`
              <br>
              <p>Check the export or exports to download</p>
              `,
          contains:'mat-checkbox-inner-container',
          to: 'export|.downloadExportSheet'
        },
        {
          class:'.downloadExportSheet',
          title:'Download',
          description:`
              <br>
              <p>Click on Download</p>
              `,
          contains:'downloadExportSheet',
          to: 'export|close'
        },

      ]
    }
  },
  pt:{
    '/': {
      icon: "home",
      title: "Página inicial",
      data: [
        {
          class:'mat-nav-list > div:nth-child(1)',
          title:'Acompanhamento presencial e tratamento das incoerências',
          description:`
      <p>Após ter clicado em « Acompanhamento presencial e tratamento das incoerências ». As equipas atribuidas ao colaborador conectado estão afixadas</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'timesheet|[use="sites_list"]:first-child'
        },
        {
          class:'mat-nav-list > div:nth-child(2)',
          title:'',
          description:``
        },
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Exportação de registo',
          description:`
      <strong>Clicar em « Ponto de exportação »</strong>
      <p>Os blocos de tempo exportados estão na lista ao nível do ponto de exportação.</p>
      `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
        }
      ]
    },
    timesheet: {
      icon: "av_timer",
      title: "Acompanhamento presencial e tratamento das incoerências",
      data: [
        {
          class:'[use="sites_list"]:first-child',
          title:'Guia',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Clicar no site a visualizar</li>
  </ul>`,
          contains:'[use="sites_list"]:first-child mat-list-item-content',
          to: 'timesheet|[use="teams_list"]:nth-child(1)'
        },
        {
          class:'[use="teams_list"]:nth-child(1)',
          title:'Guia',
          description:`<ul class="ul-left-pd ul-top-pd">
      <li>Clicar em equipa</li>
      </ul>`,
          to: 'timesheet|[use="persons_list"]:first-child'
        },
        {
          class:'[use="persons_list"]:first-child',
          title:'Guia',
          description:`<ul class="ul-left-pd ul-top-pd">
              <li>Clicar no agente a consultar ou validar</li>
        </ul>`,
          to: 'timesheet|.accordin'
        },
        {
          class:'.accordin',
          title:'Consultar blocos de tempo',
          description:`
            <ul>
                <li>Os blocos de tempo do agente estão aparentes</li>
            </ul>
            `,
          useQuestion:true,
          suggestion: [
            'timesheet|.regenerer',
            'timesheet|.validate' ,
            'timesheet|#g_data .dataset:nth-child(1)' ,
            'timesheet|#g_data .dataset:nth-child(2)' ,
            'timesheet|#g_data .dataset:nth-child(3)'
          ]
        },
        {
          class:'.formExport',
          title:'Exportação dos blocos de tempo',
          description:`
        <ul>
          <li>
            Para exportar o conteúdo dos blocos de tempo para o formato CSV:
            <ul  class="ul-left-pd ul-top-pd">
                <li>Inroduzir a data de início</li>
                <li>Introduzir a data de fim</li>
                <li>Clicar em « Exportação »</li>
            </ul>
          </li>
        </ul>
      `,
          useQuestion:true,
        },
        {
          class:'#g_data .dataset:nth-child(1)',
          title:'O previsto',
          description:`<p>
          Os dados presenciais previstos para o colaborador. Esses dados são recolhidos a partir da ferramentade planificação e de MYCongés.
  </p>`,
          to:'#g_data .dataset:nth-child(2)',
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(2)',
          title:'O realizado',
          description:`<p>
    Ao estados de presenças realizados pelo colaborador.
  </p>`,
          to:'#g_data .dataset:nth-child(3)',
          actions: [
            {
              label: 'Prev',
              action: 'back',
              class: 'btn'
            },
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'#g_data .dataset:nth-child(3)',
          title:'O realizado validado ',
          description:`<p>
          O resultado do cruzamento entre os dados do previsto e os do realizado nesse dia.<br>
  <strong> Nota: </strong> Nenhuma validação possível antes do fim do turno.
  </p>`,
        to: 'timesheet|.motifs-card'
        },
        {
          class:'.regenerer',
          title:'Regenerar a planificação',
          description:`
          <ul>
            <li>Clicar no botão regenerar previsto. O previsto aparece se esse agente tem um previsto nesse dia.</li>
            <li><strong style="color: red">NOTA:</strong> A regeneração do previsto só é possível nos casos de ausência do previsto.</li>
          </ul>
        `,
          useQuestion:true
        },
        {
          class:'.validate',
          suggestion: [
            'timesheet|#g_data .dataset:nth-child(3)'
            ],
          title:'Validar os blocos de tempo',
          description:`
      <ul>
        <li>Justificar as incoerências em duplicado clicando no bloco de incoerências, o pop-up dos motivos aparece par informar ali os motivos, É possível dividir os blocos de tempos ao alterar as durações.</li>
        <li>Clicar em salvaguardar</li>
        <li>Assinalar o botão « Validar »</li>
      </ul>
    `,
          useQuestion:true
        },
        {
          class:'.motifs-card',
          title:'O realizado validado ',
          description:`

  <p>Ao clicar no bloco de tempos de incoerências, aparece uma janela pop-up para informar dos motivos de incoerências. Os motivos de incoerências aparecem ao nível da lista suspensa segundo a natureza da incoerência. Distiguem-se duas listas, uma lista para as incoerências a menos t outra para as incoerências a mais. É possível dividir as durações alterando as horas.</p>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-content .mat-grid-list',
          title:'0 realizado validado ',
          description:`
          <p>É possível separar os blocos de tempo para:</p>
  <ul>
    <li>1. mudar o motivo</li>
    <li>2. clicar no intervalo de tempo</li>
    <li>3. Alterar as horas</li>
  </ul>
  `,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class:'.motifs-card .mat-card-actions .mat-button:nth-child(2)',
          title:'O realizado validado ',
          description:`Validar`,
          to: 'timesheet|close'
        }
      ]

    },
    mytimesheet: {
      icon: "timelapse",
      title: "Os meus estados de presença",
      data: [
        {
          class:'.accordin',
          title:'Consultar blocos de tempo',
          description:`
            <ul>
                <li>Os blocos de tempo do agente estão aparentes.</li>
            </ul>
            `,
          useQuestion:true,
          }
      ]
    },
    "export": {
      icon: "import_export",
      title: "Exportação de registo",
      data: [
        {
          class:'mat-nav-list > div:nth-child(3)',
          title:'Exportação de registo',
          description:`
      <p>Os blocos de tempo exportados estão na lista ao nível do ponto de exportação.</p>
      <p>Clicar no « Ponto de exportação » </p>    `,
          contains:'mat-list-item-content',
          useQuestion:true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
          /*suggestion: ['timesheet|.accordin']*/
        },
        {
          class:'.mat-row .mat-checkbox-inner-container',
          title:'Ponto de exportação',
          description:`
              <br>
              <p>Assinalar a exportação ou as exportações para download</p>
              `,
          contains:'mat-checkbox-inner-container',
          to: 'export|.downloadExportSheet'
        },
        {
          class:'.downloadExportSheet',
          title:'Download',
          description:`
              <br>
              <p>Clicar em Download</p>
              `,
          contains:'downloadExportSheet',
          to: 'export|close'
        },

      ]
    }
  },
  es: {
    '/': {
      icon: 'home',
      title: 'Página de inicio',
      data: [
        {
          class: 'mat-nav-list > div:nth-child(1)',
          title: 'Control de la presencia y tratamiento de las incoherencias',
          description: `
      <p>Después de hacer clic en « Control de la presencia y tratamiento de las incoherencias», se mostrarán los equipos asignados al colaborador conectado.</p>
      `,
          contains: 'mat-list-item-content',
          useQuestion: true,
          to: 'timesheet|[use="sites_list"]:first-child'
        },
        {
          class: 'mat-nav-list > div:nth-child(2)',
          title: '',
          description: ``
        },
        {
          class: 'mat-nav-list > div:nth-child(3)',
          title: 'Exportación fichaje',
          description: `
      <strong>Haga clic en « Exportación Fichaje »</strong>
      <p>los bloques de tiempo exportados serán enumerados a nivel de exportación fichaje .</p>
      `,
          contains: 'mat-list-item-content',
          useQuestion: true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
        }
      ]
    },
    timesheet: {
      icon: 'av_timer',
      title: 'Control de la presencia y tratamiento de las incoherencias',
      data: [
        {
          class: '[use="sites_list"]:first-child',
          title: 'Guía',
          description: `<ul class=\"ul-left-pd ul-top-pd\"> <li>Haga clic en el sitio para visualizarlo</li> </ul>`,
          contains: '[use="sites_list"]:first-child mat-list-item-content',
          to: 'timesheet|[use="teams_list"]:nth-child(1)'
        },
        {
          class: '[use="teams_list"]:nth-child(1)',
          title: 'Guía',
          description: `<ul class=\"ul-left-pd ul-top-pd\"> <li> Haga clic en el equipo </li> </ul>`,
          to: 'timesheet|[use="persons_list"]:first-child'
        },
        {
          class: '[use="persons_list"]:first-child',
          title: 'Guía',
          description: `<ul class=\"ul-left-pd ul-top-pd\"> <li>Haga clic en el agente a consultar o validar </li> </ul>`,
          to: 'timesheet|.accordin'
        },
        {
          class: '.accordin',
          title: 'Ver bloques de tiempo',
          description: `<ul><li> Se visualizan los bloques de tiempo del agente </li></ul>`,
          useQuestion: true,
          suggestion: [
            'timesheet|.regenerer',
            'timesheet|.validate' ,
            'timesheet|#g_data .dataset:nth-child(1)' ,
            'timesheet|#g_data .dataset:nth-child(2)' ,
            'timesheet|#g_data .dataset:nth-child(3)'
          ]
        },
        {
          class: '.formExport',
          title: 'Exportar bloques de tiempo',
          description: `<ul> <li> Para exportar el contenido de los bloques de tiempo en formato CSV : <ul  class=\"ul-left-pd ul-top-pd\"> <li> Introduzca la fecha de inicio </li> <li> Introduzca la fecha de finalización </li> <li> Haga clic en «Exportar» </li> </ul> </li> </ul>`,
          useQuestion: true,
        },
        {
          class: '#g_data .dataset:nth-child(1)',
          title: 'El previsto',
          description: `<p> Datos de asistencia previstos para el colaborador: Estos datos se recogen de la herramienta de planificación y de MyCongés. </p>`,
          to: '#g_data .dataset:nth-child(2)',
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class: '#g_data .dataset:nth-child(2)',
          title: 'El realizado',
          description: `<p>Registros de asistencia realizados por el colaborador. </p>`,
          to: '#g_data .dataset:nth-child(3)',
          actions: [
            {
              label: 'Prev',
              action: 'back',
              class: 'btn'
            },
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class: '#g_data .dataset:nth-child(3)',
          title: 'El realizado validado ',
          description: `<p>El resultado del cruce entre los datos de lo previsto y los de lo realizado. <br> <strong> NB: </strong> : No es posible ninguna validación antes del final del turno. </p>`,
          to: 'timesheet|.motifs-card'
        },
        {
          class: '.regenerer',
          title: 'Regenerar la agenda',
          description: `<ul> <li>Haga clic en el botón regenerar previsto. El previsto se visualizará si este agente tiene un previsto para este día </li> <li><strong style=\"color: red\">NB:</strong>: La regeneración del previsto sólo es posible en caso de ausencia del previsto.</li> </ul>`,
          useQuestion: true
        },
        {
          class: '.validate',
          suggestion: [
            'timesheet|#g_data .dataset:nth-child(3)'
          ],
          title: 'Validar los bloques de tiempo',
          description: `<ul> <li>Justificar incoherencias haciendo doble clic en el bloque de incoherencias, se abrirá la ventana emergente de motivos para rellenar los motivos. Es posible dividir los bloques de tiempo modificando las duraciones.</li> <li>Haga clic en Guardar</li> <li> Marque el botón « Validar »`,
          useQuestion: true
        },
        {
          class: '.motifs-card',
          title: 'El realizado validado ',
          description: `<p> Al hacer clic en el bloque de tiempo de incoherencia, se abre una ventana emergente en la que se pueden introducir los motivos de la incoherencia. Los motivos de la incoherencia se muestran en la lista desplegable, en función del tipo de incoherencia. Se distinguen dos listas, una para las incoherencias de menos y otra para las de más. Es posible dividir las duraciones modificando las horas. .</p>`,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class: '.motifs-card .mat-card-content .mat-grid-list',
          title: 'El realizado validado ',
          description: `<p> Es posible dividir los bloques de tiempo, para hacerlo:</p> <ul> <li>1. cambiar el motivo</li> <li>2. haga clic en el intervalo de tiempo</li> <li>3. Modificar las horas</li> </ul>`,
          actions: [
            {
              label: 'Next',
              action: 'next',
              class: 'btn'
            }
          ]
        },
        {
          class: '.motifs-card .mat-card-actions .mat-button:nth-child(2)',
          title: 'El realizado validado ',
          description: `Validar`,
          to: 'timesheet|close'
        }
      ]

    },
    mytimesheet: {
      icon: 'timelapse',
      title: 'Mis registros de presencia',
      data: [
        {
          class: '.accordin',
          title: 'Ver bloques de tiempo',
          description: `<ul><li>Se muestran los bloques de tiempo del agente</li></ul>`,
          useQuestion: true,
        }
      ]
    },
    'export': {
      icon: 'import_export',
      title: 'Exportación fichaje',
      data: [
        {
          class: 'mat-nav-list > div:nth-child(3)',
          title: 'Exportación fichaje',
          description: ` <p>Los bloques de tiempo exportados aparecen en exportación fichaje.</p> <p>Haga clic en « Exportar fichaje»</p> `,
          contains: 'mat-list-item-content',
          useQuestion: true,
          to: 'export|.mat-row .mat-checkbox-inner-container'
          /*suggestion: ['timesheet|.accordin']*/
        },
        {
          class: '.mat-row .mat-checkbox-inner-container',
          title: 'Exportación fichaje ',
          description: `<br> <p>Marcar la exportación o exportaciones a descargar</p> `,
          contains: 'mat-checkbox-inner-container',
          to: 'export|.downloadExportSheet'
        },
        {
          class: '.downloadExportSheet',
          title: 'Descargar',
          description: `<br> <p>Haga click en Descargar</p> `,
          contains: 'downloadExportSheet',
          to: 'export|close'
        },

      ]
    }
  },

};



// WEBPACK FOOTER //
// ./src/app/mock/Guide.ts